import { getTireAvailabilityBadge } from "./tireAvailability";
import { getTireAvailabilityDetails } from "./tireAvailabilityDetails";

export const PAIR_KIND = {
  SET: "set",
  PAIR: "pair",
};

// Lower rank = better availability. A pair is only as available as its worst tire.
const AVAILABILITY_RANK = {
  local: 0,
  preorder: 1,
  eu: 2,
  ondemand: 3,
  out: 4,
};

export function getPairKind(pair) {
  return pair && pair.set ? PAIR_KIND.SET : PAIR_KIND.PAIR;
}

export function getPairProducts(pair) {
  if (!pair) return [];
  if (pair.set) return [pair.set];
  return [pair.front, pair.rear].filter(Boolean);
}

export function getPairKey(pair) {
  if (!pair) return "";
  if (pair.familyKey) return pair.familyKey;
  return getPairProducts(pair)
    .map((product) => product.ean)
    .join("-");
}

export function getPairPrice(pair) {
  if (!pair) return 0;
  if (pair.totalPrice != null) return Number(pair.totalPrice) || 0;
  return getPairProducts(pair).reduce(
    (sum, product) => sum + (Number(product.price) || 0),
    0
  );
}

export function getPairBrand(pair) {
  if (!pair) return "";
  return pair.brand || (pair.set && pair.set.brand) || (pair.front && pair.front.brand) || "";
}

export function getPairTitle(pair) {
  if (!pair) return "";
  return pair.displayName || (pair.set && pair.set.displayName) || "";
}

export function getPairAvailability(pair) {
  const badges = getPairProducts(pair).map(getTireAvailabilityBadge);
  if (badges.length === 0) return { kind: "out", label: "לא במלאי" };
  return badges.reduce((worst, badge) =>
    AVAILABILITY_RANK[badge.kind] > AVAILABILITY_RANK[worst.kind] ? badge : worst
  );
}

export function isPairLocalStock(pair) {
  return getPairAvailability(pair).kind === "local";
}

// The notice shown on a European-stock set or matched pair. Null when every
// tire in the pair is local, preorder, or out of stock.
export function getPairEuropeanDetails(pair, ctx) {
  const products = getPairProducts(pair);
  for (let index = 0; index < products.length; index += 1) {
    const details = getTireAvailabilityDetails(products[index], ctx);
    if (details.kind === "eu") {
      return details;
    }
  }

  return null;
}

export function formatIls(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "";
  // Whole shekels stay whole; agorot always show two digits (₪1,673.10, not ₪1,673.1).
  const rounded = Math.round(value * 100) / 100;
  const digits = Number.isInteger(rounded) ? 0 : 2;
  return `₪${rounded.toLocaleString("he-IL", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
}
